import { Component, Inject, OnInit, Optional ,Input, ViewEncapsulation } from '@angular/core';
// Ask this --> about material module on importing
import { MatDialogRef, MAT_DIALOG_DATA, MatInputModule } from '@angular/material';
import { DialogData, RadioEventData } from '../../model/data.model';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
    selector: 'app-error-handler',
    templateUrl: './error-handler.component.html',
    styleUrls: ['./error-handler.component.css']
})
export class ErrorHandlerComponent implements OnInit {

    radioEventData: RadioEventData;
    errorResponse: any;
    classNameObtained: string;
    public title: string;
    private msg: string;
    statusMessage: any;
    error: Array<any> = [];
    // tslint:disable-next-line: variable-name
    display_msg: any = '';
    errroMesageInfo : any;
    isInternalServerErr = false;
    private callback: Function = () => console.log('dialog closed');

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private dialogRef: MatDialogRef<ErrorHandlerComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: DialogData) {

        // Getitng response from modal data
        this.errroMesageInfo = data;
        this.statusMessage = data['statusdata'];
        if(this.statusMessage !== 500 ) {
            this.isInternalServerErr = false;
            this.errorResponse = data['errorData'];
        } else {

            this.isInternalServerErr = true;


        }

        if (this.errorResponse) {
            this.create_display_msg('Error', this.errorResponse);
        }

        // if(this.isInternalServerErr) {
        //     this.create_display_msg('Error', this.errorResponse);

        // }




    }

   

    create_display_msg(key: string, massege: any) {
        if (typeof massege === 'object') {
            if (massege instanceof Array) {
                this.create_display_msg(key, massege[0]);
            } else {
                // tslint:disable-next-line: forin
                for (const keys in massege) {
                    this.create_display_msg(keys, massege[keys]);
                }
            }
        } else {
            this.error.push({ key, msg: massege });
        }
    }

    close() {
        
        this.callback();
        this.dialogRef.close();
    
        
    }

    ngOnInit() {
        localStorage.clear();
    }


    reloadPage() {
        const urlOBtained = this.router['url'];
        this.router.navigate([urlOBtained]).then(() => {
            window.location.reload();
        });
    }
}




